/**
 * Form utility functions for SmartSend
 */

/**
 * Extracts and capitalizes the first name from a full name string
 * @param {string} fullName - The full name to extract from
 * @returns {string} The capitalized first name
 */
export const getFirstName = (fullName) =>
  fullName.split(' ')[0].replace(/^./, char => char.toUpperCase());
